import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  EmailConfiguration,
  DomainVerification,
  DomainVerificationStatus,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const DomainVerificationRefreshIntervalMinutes = 1;

export const DefaultDomainName = 'Vertexinc.com';

const useConfiguration = (
  gatewayEndPoint: string,
  key: string,
): [EmailConfiguration, NotificationData] => {
  const [configuration, setConfiguration] = React.useState(null);
  const [configurationNotification, setConfigurationNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getConfiguration = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      const emailConfiguration: EmailConfiguration = await api.correspondence.getEmailConfigurationV41();

      Logging.Info('Get Email Configuration:', emailConfiguration);

      setConfiguration(emailConfiguration);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Configuration Read Error',
        description: 'Unable to read Configuration',
        error: error as ResponseError,
      };
      setConfigurationNotification(notification);
    }
  };

  React.useEffect(() => {
    Logging.Info('useConfiguration:', key);

    dispatch(getConfiguration());

    return (): void => {
      setConfiguration(null);
      setConfigurationNotification(null);
    };
  }, [key]);

  return [configuration, configurationNotification];
};

export default useConfiguration;
